// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Ie_G","right":"Footer_right__22SbG","buttons":"Footer_buttons__xIUlZ"};